export const translations = {
  en: {
    // Home Screen
    arcadeTitle: "Starworks",
    chooseGame: "Choose a game to play!",

    // Hero
    heroLine1: "Play games.",
    heroLine2Pre: "Earn",
    heroStars: "Stars",
    heroLine3Pre: "Spend on",
    heroFun: "fun",
    heroSubPre: "Top games",
    heroSubReward: "reward",
    heroSubMid: "you. Bottom games",
    heroSubCost: "cost",
    heroSubEnd: "stars.",
    startPlaying: "Start Playing",

    // Sidebar
    navHome: "Home",
    navLeaderboard: "Leaderboard",
    navRewards: "Rewards",
    navMissions: "Missions",
    navHowToPlay: "How to Play",
    navPixels: "Pixels",
    pixelsTitle: "My Avatar",
    pixelsDisplay: "Display",
    pixelsAlbum: "My Album",
    pixelsNew: "New",
    pixelsAll: "All",
    pixelsPopular: "Popular",
    pixelsGridSize: "Grid Size",
    pixelsHideGrid: "Hide Grid",
    pixelsShowGrid: "Show Grid",
    pixelsPublish: "Publish",
    pixelsPublished: "Published",
    pixelsHeart: "Heart",
    pixelsUnheart: "Remove heart",
    pixelsPopularHint: "Only pictures with more than 100 hearts.",
    pixelsDisplayEmpty: "No pictures yet. Publish yours to show it here.",
    pixelsAlbumEmpty: "Pictures you publish will show up here.",
    pixelsColourPicker: "Colour Picker",
    pixelsHex: "HEX",
    pixelsCursor: "Cursor",
    pixelsMode: "Mode",
    pixelsSimple: "Simple",
    pixelsAdvanced: "Advanced",
    pixelsShortcuts: "Shortcuts",
    pixelsShortcutUp: "Up",
    pixelsShortcutDown: "Down",
    pixelsShortcutLeft: "Left",
    pixelsShortcutRight: "Right",
    pixelsShortcutPut: "Put",
    pixelsShortcutDelete: "Delete",
    pixelsUndo: "Undo",
    pixelsRedo: "Redo",
    pixelsDelete: "Delete",
    pixelsClear: "Clear",
    pixelsSelected: "Selected Pixel",
    pixelsHint: "Use cursor or arrow keys to move. Click to fill pixel.",
    navLanguages: "Learn English",
    languagesEyebrow: "English",
    languagesTitle: "Learn English",
    languagesSubtitle: "Learn, then practise. Tap Hear to listen.",
    languagesBack: "All lessons",
    languagesLevel: "Level",
    languagesLessonMeta: "{teach} to learn · {practice} to practise",
    languagesKindGrammar: "Grammar",
    languagesKindTyping: "Typing",
    languagesKindConversation: "Conversation",
    languagesKindSpeak: "Speaking",
    languagesKindVocab: "Vocabulary",
    languagesTeachLabel: "Learn",
    languagesPracticeLabel: "Practise",
    languagesNewWord: "New",
    languagesExample: "Example",
    languagesHear: "Hear",
    languagesISaidIt: "I said it",
    languagesSpeakHint: "Listen, say it, then tap I said it.",
    languagesTypePlaceholder: "Type your answer…",
    languagesOrderHint: "Tap words to build the sentence",
    languagesTeachCount: "{count} new items",
    languagesStartLearning: "Start",
    languagesStartPractice: "Practise",
    languagesCheck: "Check",
    languagesContinue: "Continue",
    languagesQuit: "Quit",
    languagesCorrect: "Nice! +1",
    languagesWrong: "−1 · {answer}",
    languagesDoneEyebrow: "Done",
    languagesDoneTitle: "Well done, {name}!",
    languagesNameTitle: "What’s your name?",
    languagesNameSubtitle: "We only ask once.",
    languagesNamePlaceholder: "Your name",
    languagesNameSave: "Continue",
    languagesDoneScore: "{correct} right, {wrong} wrong ({total} total).",
    languagesDonePoints: "Stars: {points}",
    languagesSessionPoints: "Stars: {points}",
    languagesRetry: "Again",
    languagesLessonDone: "Done",
    languagesLessonNotDone: "Not done",
    languagesLessonDoneSaved: "Saved as Done.",
    howToEyebrow: "Quick guides",
    howToTitle: "How to Play",
    howToSubtitle:
      "Pick a game to see a short demo and the steps to win. More games will appear here as we add them.",
    howToAllLabel: "All",
    howToAllTitle: "All games",
    howToAllSubtitle:
      "Open any guide below — or pick a game from the tabs above.",
    howToDemoBadge: "Video",
    howToGuideBadge: "Guide",
    howToPlaybackSpeed: "Speed",
    howToPlayCta: "Play this game",
    howToCardHelp: "How to play",
    knowHowTitle: "Do you know how to play this game?",
    knowHowMessage:
      "You can jump into the game now, or open a short how-to first. Checking the guide won’t spend any stars.",
    knowHowYes: "Yes, let’s play",
    knowHowShowMe: "Show me how",
    knowHowDontShow: "Don’t show this again",
    howToHangmanSteps:
      "Start a round and look at the blank letters.\nTap or type letters to guess the word.\nAvoid too many wrong guesses before the hangman is complete.",
    howToHangmanTip: "Tip: Start with common vowels (A, E, I, O, U) to reveal the word faster.",
    howToFillerSteps:
      "A word appears with one missing letter.\nChoose the correct letter before time runs out.\nFirst-try answers earn bonus stars.",
    howToFillerTip: "Tip: Read the whole word first — sound it out — then pick the blank.",
    howToFlashcardsSteps:
      "A math card appears with a problem.\nType the answer and check it.\nCorrect answers earn 2 stars — wrong answers earn nothing.",
    howToFlashcardsTip:
      "Tip: Work carefully — wrong answers give nothing, so take your time.",
    howToDinoSteps:
      "Press Space or click to jump.\nLeap over obstacles as the run speeds up.\nSurvive as long as you can for a high score.",
    howToDinoTip: "Tip: Jump a little early — late jumps clip the cactus.",
    howToMazeSteps:
      "Use arrow keys or WASD to move.\nFind the path from the start to the goal.\nFinish in as few moves as you can.",
    howToMazeTip: "Tip: Plan two turns ahead so you don’t backtrack into dead ends.",
    howToOpsTicklesSteps:
      "Move with ← → and launch star shots with Space or the middle button.\nOnly shoot stars whose math equals the number in the starburst.\nLet other stars pass. Don't hit or shoot planes, and don't let a matching star slip by — a miss restarts the whole game.",
    howToOpsTicklesTip:
      "Tip: Watch the starburst number. After about five hits it changes — modes stay hidden.",
    howToChessSteps:
      "Your name is at the top. Under If you want, choose Computer or Human. Nothing is chosen for you.\nChoose a mode: Beginner, Easy, Intermediate, Hard, or Master. Beginner is the weakest computer. Master is the strongest.\nIf you choose Human, the player menu lists other people waiting in that same mode, from A to Z. Nothing is chosen until you pick a name.\nIf nobody is waiting in your mode, press Notify me. A note appears when someone in that mode shows up.\nPress Select after the required choices. You play white and they play black. Each of you sees your own pieces at the bottom.\nTap a piece, then tap a highlighted square. Play until someone loses.",
    howToChessTip:
      "Tip: Both players choose Human so their names appear. The person who presses Select plays white.",
    howToSolitaireSteps:
      "The cards are dealt. Build four piles by suit, ace to king.\nStacks on the table go down by one and switch color. Only a king can fill an empty column.\nTap the flower deck to draw. Double-tap a card to send it up when it fits.",
    howToSolitaireTip:
      "Tip: Turn the deck over when it runs out. The fastest clear wins the board.",
    explorer: "Explorer",
    level: "Level",

    // Top bar
    searchPlaceholder: "Search games, rewards…",
    searchGames: "Search games",
    searchResultsTitle: "Did you mean…",
    searchResultsSubtitle: "Games matching “{query}”",
    searchResultsHint: "Pick a game to play",
    searchNoResults: "No games matched that search. Try another name.",
    stars: "Stars",
    coins: "Stars",

    // Sections
    earnStars: "Earn Stars",
    spendStars: "Spend Stars",
    playAndEarn: "Play & earn",
    scrollEarnPrev: "Scroll earn games left",
    scrollEarnNext: "Scroll earn games right",

    // Rewards card
    keepGoing: "Keep going!",
    rewardsCardText: "Complete games and missions to earn amazing rewards.",
    viewRewards: "View Rewards",

    // Rewards page
    rewardsEyebrow: "3D Printed Gifts",
    rewardsTitle: "Complete missions to win rewards",
    rewardsSubtitle:
      "Real 3D-printed gifts for quest winners. Browse the gallery and pick your next prize.",

    // Missions page
    missionsEyebrow: "Quest board",
    missionsTitle: "Missions",
    missionsSubtitle:
      "Play games to complete quests, earn mega stars, and fill the board with your own mission posts.",
    missionYourStars: "Your stars",
    missionStarsHint: "Earned in games & missions. Spent only on Rewards.",
    missionCompleteBanner: "Mission complete! +{points} stars — {names}",
    missionStatusInProgress: "In progress",
    missionStatusComplete: "Complete",
    missionStatusClaimed: "+ stars earned",
    missionEmpty: "Empty slot",
    missionEmptyHint: "This mission piece is waiting to be filled.",
    missionClose: "Close",
    missionUntitled: "Untitled mission",
    missionsLoadError: "Could not load missions. Please try again.",
    missionFill: "Fill mission",
    missionEdit: "Edit mission",
    missionEditorTitle: "Mission",
    missionEditorSubtitle: "Add text and a picture for this mission slot.",
    missionTitleLabel: "Title",
    missionTextLabel: "Text",
    missionPictureLabel: "Picture",
    missionNoPicture: "No picture yet",
    missionUploadPicture: "Upload picture",
    missionUploading: "Uploading…",
    missionSave: "Save mission",
    missionFillRequired: "Add a title, text, or picture before saving.",
    missionUploadError: "Could not upload picture. Please try again.",
    missionSaveError: "Could not save mission. Please try again.",

    rewardPrintTag: "3D Print",
    rewardStatusFirst: "First unlock",
    rewardStatusLocked: "Locked",
    rewardStatusComing: "Coming soon",
    rewardBenchy: "Benchy Boat",
    rewardBenchyDesc:
      "The classic 3DBenchy tugboat — our first reward you can unlock by completing quests.",
    rewardTurtle: "Flexible Turtle",
    rewardTurtleDesc:
      "An articulated sea turtle fidget print — bend the shell and flippers after you unlock it.",
    rewardNinjaStar: "Ninja Star",
    rewardNinjaStarDesc:
      "A six-pointed throwing star print — sharp looks, soft landings, and serious bragging rights.",
    rewardTicTacLauncher: "Tic Tac Launcher",
    rewardTicTacLauncherDesc:
      "A handheld 3D-printed candy launcher — load a pack and fire citrus mix across the room.",
    rewardTicTacLauncherAdvanced: "Tic Tac Launcher Advanced",
    rewardTicTacLauncherAdvancedDesc:
      "The upgraded skeleton-frame launcher — more power, more style, more citrus chaos.",
    rewardTicTacBullet: "Tic-Tac Bullet",
    rewardTicTacBulletDesc:
      "A printable ammo capsule for the Tic Tac launchers — load up and fire away.",
    rewardTicTacBoxAdapter: "Tic Tac Box Adapter from Big Box to Small Box",
    rewardTicTacBoxAdapterDesc:
      "A sleeve that lets big-box Tic Tacs fit the small-box launcher — one pack, any shooter.",
    rewardGyro: "Gyro Spinner",
    rewardGyroDesc: "A smooth-spinning gyro fidget with nested rings.",
    rewardGravitraxRails: "GraviTrax Track Rails",
    rewardGravitraxRailsDesc:
      "Curved GraviTrax-compatible track rails for building bigger marble runs.",
    rewardFlyingBlade: "Flying Blade",
    rewardFlyingBladeDesc:
      "A pull-string propeller launcher — yank the ripcord and send the blade flying.",
    rewardFlyingBladePropeller: "Flying Blade (Propeller)",
    rewardFlyingBladePropellerDesc:
      "The orange three-loop propeller disc — the spinning blade for the flying blade.",
    claimReward: "Claim Reward",
    rewardClaimLocked: "Locked",
    claimRewardTitle: "Claim reward",
    claimRewardSubtitle:
      "Choose a print color and tell us where to ship it.",
    rewardClaimName: "Full name",
    rewardClaimNamePlaceholder: "Name for shipping",
    rewardClaimAddress: "Shipping address",
    rewardClaimAddressPlaceholder: "Street, city, postal code, country",
    rewardClaimAddressShortcut: "Saved address",
    rewardClaimAddressShortcutPlaceholder: "Choose a saved address…",
    rewardClaimAddNewAddress: "Add New Address",
    rewardClaimAddAnAddress: "Add an Address",
    rewardClaimAddAddressSubtitle: "Type the shipping address, then save it.",
    rewardClaimAddressHint: "Choose a saved address or add a new one below.",
    rewardClaimSaveAddress: "Save Address",
    rewardClaimAddressSaved: "Address saved — you can pick it next time.",
    rewardClaimColor: "Print color",
    rewardClaimSubmit: "Submit claim",
    rewardClaimNameRequired: "Please enter the shipping name.",
    rewardClaimAddressRequired: "Please enter a shipping address.",
    rewardClaimColorRequired: "Please choose a print color.",
    rewardClaimSuccess: "Claim submitted! We'll get it ready to ship.",
    rewardClaimError: "Could not submit your claim. Please try again.",
    rewardClaimInsufficientStars: "You need more stars to claim this reward.",
    rewardClaimNeedStars: "Need {cost} stars",

    // Stats bar
    dayStreak: "Day Streak",
    gamesPlayed: "Games Played",
    totalStars: "Total Stars",
    nextReward: "Next Reward",
    starsToGo: "stars to go",

    // Games
    hangman: "Hangman",
    hangmanDescription: "Guess the word\none letter at a time.",
    filler: "Filler",
    fillerDescription: "Fill the blanks,\nshow what you know!",
    flashcards: "Flashcards",
    flashcardsDescription: "Solve math cards,\nearn stars!",
    playNow: "Play Now →",

    // Top Menu
    back: "Back",

    // Hangman Game
    spellTheWord: "🎯 Spell the Word!",
    wrongGuesses: "Wrong Guesses",
    category: "Category",
    readyToPlay: "Ready to play!",
    headDrawn: "Head drawn...",
    bodyAdded: "Body added...",
    leftArm: "Left arm...",
    rightArm: "Right arm...",
    leftLeg: "Left leg...",
    gameOver: "Game Over!",
    theWordWas: "The word was:",
    amazing: "🎉 Amazing! You spelled it correctly!",
    greatTry: "💪 Great try! Let's try another word!",
    startGame: "🎮 Start Game",
    playAgain: "🎉 Play Again!",
    tryAnotherWord: "🔄 Try Another Word!",
    loading: "Loading...",

    // Filler Game
    fillTheLetter: "🔤 Fill the Letter!",
    time: "Time:",
    score: "Score:",
    perfectFirstTry: "🎉 Perfect! First try! +2 points",
    correct: "✅ Correct! +1 point",
    tryAgain: "❌ Try again!",
    attempts: "Attempts:",
    gameOverTitle: "🎮 Game Over!",
    finalScore: "Final Score:",
    points: "points",
    wordsCompleted: "Words Completed:",
    gameInstructions:
      "Fill in the missing letter in each word!\nGet it right on the first try for 2 points!",
    timesUp: "Time's up! Game Over!",
    greatJob: "Great job! Keep going until time runs out!",
    tooManyTries: "Too many tries! Moving to next word...",

    // Flashcards Game
    flashcardsTitle: "Flashcards",
    flashcardsInstructions:
      "Solve each math card before time runs out!\nCorrect answers earn 2 stars.\nWrong answers earn nothing.",
    flashcardsCorrect: "✅ Correct! +2 stars",
    flashcardsWrong: "Nothing this time — try the next card!",
    flashcardsEnterNumber: "Please enter a number.",
    flashcardsYourAnswer: "Your answer",
    flashcardsCheck: "Check",
    flashcardsAnswered: "Cards answered:",

    // Dino Game
    dinoRun: "Dino Run!",
    dinoDescription: "Run, jump,\nsurvive the chase!",
    dinoInstructions:
      "Click or press SPACEBAR to jump over obstacles!\nSurvive as long as possible!",
    jumpHint: "Click or press SPACEBAR to jump!",
    jump: "Jump",
    viewHighScores: "View High Scores",
    highScores: "High Scores",
    yourScore: "Your Score",
    yourRank: "Rank",
    noHighScores: "No high scores yet. Be the first!",
    anonymous: "Anonymous",
    close: "Close",

    // Maze Game
    maze: "Maze",
    mazeDescription: "Find your way\nthrough the maze!",
    mazeInstructions: "Use arrow keys (or WASD) to move from ✅ to 🎯.",
    mazeControls: "Use Arrow Keys / WASD to move. Reach 🎯 to win.",
    youWin: "You escaped the maze!",
    moves: "Moves",
    finalMoves: "Total Moves",

    // Ops-tickles
    opsTickles: "Ops-tickles",
    opsTicklesDescription: "Shoot the stars\nthat match the target!",
    opsTicklesInstructions:
      "Stars fall with math problems — only shoot ones that equal the starburst number!\nLet other stars pass. Don't collide, don't shoot planes, and don't shoot a wrong star.\nIf a matching star slips past, the game starts over from scratch.",
    opsTicklesHint: "← → move · Space launch",
    opsTicklesShoot: "Launch",
    opsTicklesHighScores: "Ops-tickles High Scores",
    opsTicklesTarget: "Target",
    opsTicklesTargetHint: "Shoot stars whose math equals this number",

    chess: "Chess",
    chessDescription: "Play a friend\nor the computer.",
    chessChooseMode: "Pick a mode.",
    chessModeEasy: "Easy",
    chessModeBeginner: "Beginner",
    chessModeIntermediate: "Intermediate",
    chessModeHard: "Hard",
    chessModeMaster: "Master",
    chessIfYouWant: "If you want",
    chessWantPlaceholder: "Choose",
    chessModeLabel: "Mode",
    chessModePlaceholder: "Choose a mode",
    chessChooseModeFirst: "Choose a mode first.",
    chessHuman: "Human",
    chessPlayerLabel: "Player",
    chessPlayerPlaceholder: "Choose a player",
    chessChooseFirst: "Choose Computer or Human first.",
    chessNotifyMe: "Notify me",
    chessPlayerHere: "There's a player.",
    chessChat: "Chat",
    chessChatEmpty: "Say hello.",
    chessChatPlaceholder: "Type a message",
    chessChatSend: "Send",
    chessOpponentLabel: "Opponent",
    chessOpponentPlaceholder: "Choose an opponent",
    chessNoOpponents:
      "No one else is waiting in this mode. Stay on this page — your name is on the list — and a friend on the same mode can choose you.",
    chessYouAreListed:
      "Names in this mode are listed from A to Z. Choose someone, then press Select. Or wait here and they can choose you.",
    chessSelect: "Select",
    chessSelecting: "Connecting…",
    chessYourTurn: "Your turn",
    chessOpponentTurn: "{name}'s turn",
    chessComputer: "Computer",
    chessOpponent: "Opponent",
    chessYou: "You",
    chessCheck: "Check",
    chessYouWin: "You win",
    chessYouLose: "You lose",
    chessDraw: "Draw",
    chessCheckmate: "Checkmate. That player loses.",
    chessStalemate: "Stalemate — nobody loses.",
    chessInsufficient: "Not enough pieces left to win.",
    chessOpponentLeft: "The other player left, so you win.",
    chessYouLeft: "You left the game.",
    chessWhite: "White",
    chessBlack: "Black",
    chessPlayAgain: "Play again",
    chessPromotion: "Choose a piece",
    chessConnectError: "Could not reach the other players. Is the game server running?",
    chessAlreadyPlaying: "That player just started another game. Pick someone else.",
    chessKing: "king",
    chessQueen: "queen",
    chessRook: "rook",
    chessBishop: "bishop",
    chessKnight: "knight",
    chessPawn: "pawn",

    memory: "Memory",
    memoryDescription: "Match the pairs\nwith a friend.",
    memoryIfYouWant: "If you want",
    memoryWantPlaceholder: "Choose",
    memoryPractice: "Practice",
    memoryHuman: "Play against a human",
    memoryYourTurn: "Your turn",
    memoryAllOpen: "All cards are open.",
    memoryYouHave: "You have {count} cards",
    memoryClose: "Close",
    memoryCardsError: "Could not open the cards.",
    memoryPlayerLabel: "Choose player",
    memoryPlayerPlaceholder: "Choose a player",
    memoryGo: "Go",
    memoryGoing: "Connecting…",
    memoryNoOpponents:
      "No one else is waiting. Stay on this page — your name is on the list — and a friend can choose you.",
    memoryYouAreListed:
      "Names are listed from A to Z. Choose someone, then press Go. Or wait here and they can choose you.",
    memoryConnectError: "Could not reach the other players. Is the game server running?",
    memoryAlreadyPlaying: "That player just started another game. Pick someone else.",
    memoryPlayingWith: "Playing with {name}",
    memoryYou: "You",
    memoryOpponent: "Opponent",
    memoryOpponentLeft: "The other player left.",
    memoryYouLeft: "You left the game.",

    solitaire: "Solitaire",
    solitaireDescription: "Clear the table.\nFastest time wins.",
    solitaireNewDeal: "New deal",
    solitaireWon: "You cleared the table",
    solitaireStock: "Draw a card",
    solitaireFoundation: "Foundation",
    solitaireEmpty: "Empty column",
    solitaireHint: "Hint",
    solitaireHintDraw: "Draw a card.",
    solitaireHintMove: "Move {card}.",
    solitaireHintNone: "No move to show.",
    solitaireHintNeed: "This hint costs {cost} stars.",

    // Arcade sections
    earnPoints: "Earn Points",
    spendPoints: "Spend Points",
    free: "FREE",

    // Display Name
    setDisplayName: "Set Display Name",
    chooseLanguage: "Choose your language",
    displayNameDescription: "Choose a display name to appear on leaderboards and high scores!",
    displayNamePlaceholder: "Display name (2–20 characters)",
    displayNameRequired: "Display name is required",
    displayNameTooShort: "Display name must be at least 2 characters",
    displayNameTooLong: "Display name must be 20 characters or less",
    displayNameError: "Error setting display name. Please try again.",
    saveDisplayName: "Save Display Name",
    saving: "Saving...",
    cancel: "Cancel",
    playerLabel: "Player",
    editDisplayName: "Edit display name",
    profileMenu: "Profile menu",
    playMusic: "Play music",
    muteMusic: "Mute music",
    changeLanguage: "Language",
    changeMode: "Mode",
    modePurple: "Yellow",
    modePink: "Purple",
    modeYellow: "White",
    modeBlue: "Blue",
    modeGreen: "Green",
    modeRed: "Red",
    myShipments: "My shipments",
    myShipmentsSubtitle: "Track your claimed rewards and shipping status.",
    shipmentsEmpty: "You haven’t claimed any rewards yet.",
    shipmentsError: "Could not load your shipments. Please try again.",
    shipmentStatusPending: "Pending",
    shipmentStatusOnTheWay: "On the way",
    shipmentStatusShipped: "Shipped",
    shipmentDelete: "Delete",
    shipmentDeleting: "Deleting…",
    shipmentDeleteConfirm: "Are you sure?",
    shipmentDeleteError: "Could not delete this order. Please try again.",
    reportProblem: "Report a problem",
    reportProblemSubtitle:
      "Tell us what went wrong. We’ll see your message on the admin dashboard.",
    reportProblemMessageLabel: "Message",
    reportProblemPlaceholder: "Describe the problem…",
    reportProblemSend: "Send",
    reportProblemSending: "Sending…",
    reportProblemRequired: "Please enter a message.",
    reportProblemTooLong: "Please keep your message under 2000 characters.",
    reportProblemSuccess: "Thanks — your report was sent.",
    reportProblemError: "Could not send your report. Please try again.",

    // Error messages
    insufficientPoints: "Insufficient Points",
    insufficientPointsMessage:
      "Please earn some points before playing this game!",
    ok: "OK",

    // Languages
    english: "English",
    german: "Deutsch",
  },
  de: {
    // Home Screen
    arcadeTitle: "Starworks",
    chooseGame: "Wähle ein Spiel zum Spielen!",

    // Hero
    heroLine1: "Spiele Games.",
    heroLine2Pre: "Verdiene",
    heroStars: "Sterne",
    heroLine3Pre: "Gib sie aus für",
    heroFun: "Spaß",
    heroSubPre: "Obere Spiele",
    heroSubReward: "belohnen",
    heroSubMid: "dich. Untere Spiele",
    heroSubCost: "kosten",
    heroSubEnd: "Sterne.",
    startPlaying: "Jetzt spielen",

    // Sidebar
    navHome: "Start",
    navLeaderboard: "Bestenliste",
    navRewards: "Belohnungen",
    navMissions: "Missionen",
    navHowToPlay: "So spielst du",
    navPixels: "Pixels",
    pixelsTitle: "Mein Avatar",
    pixelsDisplay: "Anzeige",
    pixelsAlbum: "Mein Album",
    pixelsNew: "Neu",
    pixelsAll: "Alle",
    pixelsPopular: "Beliebt",
    pixelsGridSize: "Rastergröße",
    pixelsHideGrid: "Raster ausblenden",
    pixelsShowGrid: "Raster einblenden",
    pixelsPublish: "Veröffentlichen",
    pixelsPublished: "Veröffentlicht",
    pixelsHeart: "Herz",
    pixelsUnheart: "Herz entfernen",
    pixelsPopularHint: "Nur Bilder mit mehr als 100 Herzen.",
    pixelsDisplayEmpty: "Noch keine Bilder. Veröffentliche deins, um es hier zu zeigen.",
    pixelsAlbumEmpty: "Bilder, die du veröffentlichst, erscheinen hier.",
    pixelsColourPicker: "Farbwähler",
    pixelsHex: "HEX",
    pixelsCursor: "Cursor",
    pixelsMode: "Modus",
    pixelsSimple: "Einfach",
    pixelsAdvanced: "Erweitert",
    pixelsShortcuts: "Tastenkürzel",
    pixelsShortcutUp: "Hoch",
    pixelsShortcutDown: "Runter",
    pixelsShortcutLeft: "Links",
    pixelsShortcutRight: "Rechts",
    pixelsShortcutPut: "Setzen",
    pixelsShortcutDelete: "Löschen",
    pixelsUndo: "Rückgängig",
    pixelsRedo: "Wiederholen",
    pixelsDelete: "Löschen",
    pixelsClear: "Leeren",
    pixelsSelected: "Ausgewähltes Pixel",
    pixelsHint: "Mit Cursor oder Pfeiltasten bewegen. Klicken zum Füllen.",
    navLanguages: "Englisch lernen",
    languagesEyebrow: "Englisch",
    languagesTitle: "Englisch lernen",
    languagesSubtitle: "Lernen, dann üben. Tippe auf Anhören.",
    languagesBack: "Alle Lektionen",
    languagesLevel: "Niveau",
    languagesLessonMeta: "{teach} lernen · {practice} üben",
    languagesKindGrammar: "Grammatik",
    languagesKindTyping: "Tippen",
    languagesKindConversation: "Gespräch",
    languagesKindSpeak: "Sprechen",
    languagesKindVocab: "Wortschatz",
    languagesTeachLabel: "Lernen",
    languagesPracticeLabel: "Üben",
    languagesNewWord: "Neu",
    languagesExample: "Beispiel",
    languagesHear: "Anhören",
    languagesISaidIt: "Gesagt",
    languagesSpeakHint: "Anhören, nachsprechen, dann auf Gesagt tippen.",
    languagesTypePlaceholder: "Antwort tippen…",
    languagesOrderHint: "Wörter antippen",
    languagesTeachCount: "{count} neu",
    languagesStartLearning: "Start",
    languagesStartPractice: "Üben",
    languagesCheck: "Prüfen",
    languagesContinue: "Weiter",
    languagesQuit: "Beenden",
    languagesCorrect: "Super! +1",
    languagesWrong: "−1 · {answer}",
    languagesDoneEyebrow: "Fertig",
    languagesDoneTitle: "Gut gemacht, {name}!",
    languagesNameTitle: "Wie heißt du?",
    languagesNameSubtitle: "Wir fragen nur einmal.",
    languagesNamePlaceholder: "Dein Name",
    languagesNameSave: "Weiter",
    languagesDoneScore: "{correct} richtig, {wrong} falsch ({total} gesamt).",
    languagesDonePoints: "Sterne: {points}",
    languagesSessionPoints: "Sterne: {points}",
    languagesRetry: "Nochmal",
    languagesLessonDone: "Fertig",
    languagesLessonNotDone: "Offen",
    languagesLessonDoneSaved: "Als Fertig gespeichert.",
    howToEyebrow: "Kurzanleitungen",
    howToTitle: "So spielst du",
    howToSubtitle:
      "Wähle ein Spiel für eine kurze Demo und die Schritte zum Gewinn. Weitere Spiele erscheinen hier, sobald wir sie hinzufügen.",
    howToAllLabel: "Alle",
    howToAllTitle: "Alle Spiele",
    howToAllSubtitle:
      "Öffne unten eine Anleitung — oder wähle ein Spiel in den Tabs oben.",
    howToDemoBadge: "Video",
    howToGuideBadge: "Anleitung",
    howToPlaybackSpeed: "Tempo",
    howToPlayCta: "Dieses Spiel spielen",
    howToCardHelp: "So spielst du",
    knowHowTitle: "Weißt du, wie man dieses Spiel spielt?",
    knowHowMessage:
      "Du kannst direkt spielen oder zuerst die kurze Anleitung ansehen. Die Anleitung kostet keine Sterne.",
    knowHowYes: "Ja, spielen",
    knowHowShowMe: "Zeig mir wie",
    knowHowDontShow: "Nicht mehr anzeigen",
    howToHangmanSteps:
      "Starte eine Runde und sieh dir die leeren Buchstaben an.\nWähle Buchstaben per Klick oder Tastatur, um das Wort zu erraten.\nVermeide zu viele Fehlversuche, bevor das Galgenmännchen fertig ist.",
    howToHangmanTip:
      "Tipp: Beginne mit häufigen Vokalen (A, E, I, O, U), um das Wort schneller freizulegen.",
    howToFillerSteps:
      "Ein Wort erscheint mit einem fehlenden Buchstaben.\nWähle den richtigen Buchstaben, bevor die Zeit abläuft.\nRichtige Antworten beim ersten Versuch bringen Bonussterne.",
    howToFillerTip:
      "Tipp: Lies zuerst das ganze Wort — sprich es aus — dann wähle die Lücke.",
    howToFlashcardsSteps:
      "Eine Mathe-Karte erscheint mit einer Aufgabe.\nTippe die Antwort ein und prüfe sie.\nRichtige Antworten geben 2 Sterne — falsche Antworten geben nichts.",
    howToFlashcardsTip:
      "Tipp: Arbeite sorgfältig — falsche Antworten bringen nichts, also nimm dir Zeit.",
    howToDinoSteps:
      "Drücke Leertaste oder klicke zum Springen.\nSpringe über Hindernisse, während der Lauf schneller wird.\nÜberlebe so lange wie möglich für eine Highscore.",
    howToDinoTip:
      "Tipp: Springe etwas früher — zu späte Sprünge treffen den Kaktus.",
    howToMazeSteps:
      "Nutze Pfeiltasten oder WASD zum Bewegen.\nFinde den Weg vom Start zum Ziel.\nSchaffe es mit möglichst wenigen Zügen.",
    howToMazeTip:
      "Tipp: Plane zwei Abbiegen voraus, damit du nicht in Sackgassen zurückläufst.",
    howToOpsTicklesSteps:
      "Bewege dich mit ← → und starte Sternschüsse mit der Leertaste oder der mittleren Taste.\nSchieße nur Sterne, deren Rechnung der Zahl im Sternburst entspricht.\nLass andere Sterne vorbeiziehen. Triff und schieße keine Flugzeuge, und lass keinen passenden Stern vorbei — ein Fehlschuss startet das ganze Spiel neu.",
    howToOpsTicklesTip:
      "Tipp: Achte auf die Zahl im Sternburst. Nach etwa fünf Treffern ändert sie sich — die Modi bleiben unsichtbar.",
    howToChessSteps:
      "Dein Name steht oben. Unter Wenn du willst wählst du Computer oder Mensch. Nichts ist vorausgewählt.\nWähle einen Modus: Anfänger, Leicht, Mittel, Schwer oder Meister. Anfänger ist der schwächste Computer. Meister ist der stärkste.\nWählst du Mensch, listet das Spielermenü andere Leute, die im selben Modus warten, von A bis Z. Nichts ist gewählt, bis du einen Namen nimmst.\nWenn in deinem Modus niemand wartet, drücke Benachrichtige mich. Ein Hinweis erscheint, sobald jemand in diesem Modus da ist.\nDrücke Auswählen, wenn die nötigen Menüs gewählt sind. Du spielst Weiß, die andere Person Schwarz. Jede sieht die eigenen Figuren unten.\nTippe eine Figur an, dann ein markiertes Feld. Spielt, bis jemand verliert.",
    howToChessTip:
      "Tipp: Beide wählen Mensch, damit die Namen erscheinen. Wer Auswählen drückt, spielt Weiß.",
    howToSolitaireSteps:
      "Die Karten liegen bereit. Baue vier Stapel nach Farbe, vom Ass bis zum König.\nAuf dem Tisch geht es um eins nach unten und die Farbe wechselt. Nur ein König füllt eine leere Reihe.\nTippe den Blumenstapel zum Ziehen. Doppeltippe eine Karte, um sie nach oben zu legen, wenn sie passt.",
    howToSolitaireTip:
      "Tipp: Dreh den Stapel um, wenn er leer ist. Die schnellste Runde gewinnt die Bestenliste.",
    explorer: "Entdecker",
    level: "Stufe",

    // Top bar
    searchPlaceholder: "Spiele, Belohnungen suchen …",
    searchGames: "Spiele suchen",
    searchResultsTitle: "Meintest du …",
    searchResultsSubtitle: "Spiele zu „{query}“",
    searchResultsHint: "Wähle ein Spiel zum Spielen",
    searchNoResults:
      "Kein Spiel passt zu dieser Suche. Probiere einen anderen Namen.",
    stars: "Sterne",
    coins: "Sterne",

    // Sections
    earnStars: "Sterne verdienen",
    spendStars: "Sterne ausgeben",
    playAndEarn: "Spielen & verdienen",
    scrollEarnPrev: "Sterne-Spiele nach links scrollen",
    scrollEarnNext: "Sterne-Spiele nach rechts scrollen",

    // Rewards card
    keepGoing: "Weiter so!",
    rewardsCardText:
      "Schließe Spiele und Missionen ab, um tolle Belohnungen zu erhalten.",
    viewRewards: "Belohnungen ansehen",

    // Rewards page
    rewardsEyebrow: "3D-gedruckte Geschenke",
    rewardsTitle: "Schließe Missionen ab und gewinne Belohnungen",
    rewardsSubtitle:
      "Echte 3D-gedruckte Geschenke für Quest-Gewinner. Stöbere in der Galerie und such dir deinen nächsten Preis aus.",

    // Missions page
    missionsEyebrow: "Quest-Brett",
    missionsTitle: "Missionen",
    missionsSubtitle:
      "Spiele Games, um Quests abzuschließen, Mega-Sterne zu verdienen und das Brett mit eigenen Missionsposts zu füllen.",
    missionYourStars: "Deine Sterne",
    missionStarsHint:
      "Verdient in Spielen & Missionen. Nur für Belohnungen ausgeben.",
    missionCompleteBanner: "Mission geschafft! +{points} Sterne — {names}",
    missionStatusInProgress: "In Arbeit",
    missionStatusComplete: "Fertig",
    missionStatusClaimed: "+ Sterne verdient",
    missionEmpty: "Leerer Platz",
    missionEmptyHint: "Dieses Missionsstück wartet darauf, ausgefüllt zu werden.",
    missionClose: "Schließen",
    missionUntitled: "Unbenannte Mission",
    missionsLoadError:
      "Missionen konnten nicht geladen werden. Bitte versuche es erneut.",
    missionFill: "Mission ausfüllen",
    missionEdit: "Mission bearbeiten",
    missionEditorTitle: "Mission",
    missionEditorSubtitle:
      "Füge Text und ein Bild für diesen Missionsplatz hinzu.",
    missionTitleLabel: "Titel",
    missionTextLabel: "Text",
    missionPictureLabel: "Bild",
    missionNoPicture: "Noch kein Bild",
    missionUploadPicture: "Bild hochladen",
    missionUploading: "Hochladen…",
    missionSave: "Mission speichern",
    missionFillRequired:
      "Bitte Titel, Text oder Bild hinzufügen, bevor du speicherst.",
    missionUploadError:
      "Bild konnte nicht hochgeladen werden. Bitte versuche es erneut.",
    missionSaveError:
      "Mission konnte nicht gespeichert werden. Bitte versuche es erneut.",

    rewardPrintTag: "3D-Druck",
    rewardStatusFirst: "Erste Freischaltung",
    rewardStatusLocked: "Gesperrt",
    rewardStatusComing: "Demnächst",
    rewardBenchy: "Benchy-Boot",
    rewardBenchyDesc:
      "Der klassische 3DBenchy-Schlepper — unsere erste Belohnung, die du durch Quests freischalten kannst.",
    rewardTurtle: "Flexible Turtle",
    rewardTurtleDesc:
      "Eine gelenkige Meeresschildkröte zum Knicken — Schale und Flossen bewegen sich nach dem Freischalten.",
    rewardNinjaStar: "Ninja Star",
    rewardNinjaStarDesc:
      "Ein sechszackiger Wurfstern aus dem Drucker — scharf im Look, weich im Aufschlag.",
    rewardTicTacLauncher: "Tic Tac Launcher",
    rewardTicTacLauncherDesc:
      "Ein handlicher 3D-gedruckter Candy-Werfer — Packung rein, Citrus Mix quer durch den Raum.",
    rewardTicTacLauncherAdvanced: "Tic Tac Launcher Advanced",
    rewardTicTacLauncherAdvancedDesc:
      "Der aufgerüstete Skeleton-Rahmen-Werfer — mehr Power, mehr Style, mehr Citrus-Chaos.",
    rewardTicTacBullet: "Tic-Tac Bullet",
    rewardTicTacBulletDesc:
      "Eine druckbare Munitionskapsel für die Tic-Tac-Werfer — laden und abfeuern.",
    rewardTicTacBoxAdapter: "Tic Tac Box Adapter from Big Box to Small Box",
    rewardTicTacBoxAdapterDesc:
      "Eine Hülse, damit große Tic-Tac-Packungen in den Kleinbox-Werfer passen — eine Packung, jeder Shooter.",
    rewardGyro: "Gyro-Spinner",
    rewardGyroDesc: "Ein flüssig drehender Gyro-Fidget mit verschachtelten Ringen.",
    rewardGravitraxRails: "GraviTrax Track Rails",
    rewardGravitraxRailsDesc:
      "Gebogene GraviTrax-kompatible Schienen für größere Kugelbahnen.",
    rewardFlyingBlade: "Flying Blade",
    rewardFlyingBladeDesc:
      "Ein Propeller-Werfer mit Zugband — reiß am Band und schick die Klinge in die Luft.",
    rewardFlyingBladePropeller: "Flying Blade (Propeller)",
    rewardFlyingBladePropellerDesc:
      "Die orangefarbene Drei-Schleifen-Propellerscheibe — die Rotorklinge für den Flying Blade.",
    claimReward: "Belohnung einlösen",
    rewardClaimLocked: "Gesperrt",
    claimRewardTitle: "Belohnung einlösen",
    claimRewardSubtitle:
      "Wähle eine Druckfarbe und gib an, wohin wir sie schicken sollen.",
    rewardClaimName: "Vollständiger Name",
    rewardClaimNamePlaceholder: "Name für den Versand",
    rewardClaimAddress: "Lieferadresse",
    rewardClaimAddressPlaceholder: "Straße, Stadt, PLZ, Land",
    rewardClaimAddressShortcut: "Gespeicherte Adresse",
    rewardClaimAddressShortcutPlaceholder: "Gespeicherte Adresse wählen…",
    rewardClaimAddNewAddress: "Neue Adresse hinzufügen",
    rewardClaimAddAnAddress: "Adresse hinzufügen",
    rewardClaimAddAddressSubtitle:
      "Tippe die Lieferadresse ein und speichere sie.",
    rewardClaimAddressHint:
      "Wähle eine gespeicherte Adresse oder füge unten eine neue hinzu.",
    rewardClaimSaveAddress: "Adresse speichern",
    rewardClaimAddressSaved:
      "Adresse gespeichert — du kannst sie beim nächsten Mal auswählen.",
    rewardClaimColor: "Druckfarbe",
    rewardClaimSubmit: "Anspruch absenden",
    rewardClaimNameRequired: "Bitte gib den Namen für den Versand ein.",
    rewardClaimAddressRequired: "Bitte gib eine Lieferadresse ein.",
    rewardClaimColorRequired: "Bitte wähle eine Druckfarbe.",
    rewardClaimSuccess: "Anspruch gesendet! Wir bereiten den Versand vor.",
    rewardClaimError:
      "Anspruch konnte nicht gesendet werden. Bitte versuche es erneut.",
    rewardClaimInsufficientStars:
      "Du brauchst mehr Sterne, um diese Belohnung einzulösen.",
    rewardClaimNeedStars: "{cost} Sterne nötig",

    // Stats bar
    dayStreak: "Tagesserie",
    gamesPlayed: "Gespielte Spiele",
    totalStars: "Sterne gesamt",
    nextReward: "Nächste Belohnung",
    starsToGo: "Sterne fehlen",

    // Games
    hangman: "Galgenmännchen",
    hangmanDescription: "Errate das Wort,\nBuchstabe für Buchstabe.",
    filler: "Lückenfüller",
    fillerDescription:
      "Fülle die Lücken,\nzeig dein Können!",
    flashcards: "Lernkarten",
    flashcardsDescription: "Löse Mathe-Karten,\nsammle Sterne!",
    playNow: "Jetzt spielen →",

    // Top Menu
    back: "Zurück",

    // Hangman Game
    spellTheWord: "🎯 Buchstabiere das Wort!",
    wrongGuesses: "Falsche Vermutungen",
    category: "Kategorie",
    readyToPlay: "Bereit zum Spielen!",
    headDrawn: "Kopf gezeichnet...",
    bodyAdded: "Körper hinzugefügt...",
    leftArm: "Linker Arm...",
    rightArm: "Rechter Arm...",
    leftLeg: "Linkes Bein...",
    gameOver: "Spiel vorbei!",
    theWordWas: "Das Wort war:",
    amazing: "🎉 Großartig! Du hast es richtig buchstabiert!",
    greatTry: "💪 Guter Versuch! Lass uns ein anderes Wort versuchen!",
    startGame: "🎮 Spiel starten",
    playAgain: "🎉 Nochmal spielen!",
    tryAnotherWord: "🔄 Versuche ein anderes Wort!",
    loading: "Laden...",

    // Filler Game
    fillTheLetter: "🔤 Fülle den Buchstaben!",
    time: "Zeit:",
    score: "Punkte:",
    perfectFirstTry: "🎉 Perfekt! Beim ersten Versuch! +2 Punkte",
    correct: "✅ Richtig! +1 Punkt",
    tryAgain: "❌ Versuche es erneut!",
    attempts: "Versuche:",
    gameOverTitle: "🎮 Spiel vorbei!",
    finalScore: "Endpunktzahl:",
    points: "Punkte",
    wordsCompleted: "Wörter abgeschlossen:",
    gameInstructions:
      "Fülle den fehlenden Buchstaben in jedem Wort ein!\nErreiche beim ersten Versuch 2 Punkte!",
    timesUp: "Zeit abgelaufen! Spiel vorbei!",
    greatJob: "Großartige Arbeit! Mach weiter, bis die Zeit abläuft!",
    tooManyTries: "Zu viele Versuche! Gehe zum nächsten Wort...",

    // Flashcards Game
    flashcardsTitle: "Lernkarten",
    flashcardsInstructions:
      "Löse jede Mathe-Karte, bevor die Zeit abläuft!\nRichtige Antworten geben 2 Sterne.\nFalsche Antworten geben nichts.",
    flashcardsCorrect: "✅ Richtig! +2 Sterne",
    flashcardsWrong: "Diesmal nichts — versuche die nächste Karte!",
    flashcardsEnterNumber: "Bitte gib eine Zahl ein.",
    flashcardsYourAnswer: "Deine Antwort",
    flashcardsCheck: "Prüfen",
    flashcardsAnswered: "Beantwortete Karten:",

    // Dino Game
    dinoRun: "Dino-Rennen!",
    dinoDescription: "Renne, springe,\nüberlebe die Jagd!",
    dinoInstructions:
      "Klicke oder drücke LEERTASTE, um über Hindernisse zu springen!\nÜberlebe so lange wie möglich!",
    jumpHint: "Klicke oder drücke LEERTASTE zum Springen!",
    jump: "Springen",
    viewHighScores: "Bestenliste anzeigen",
    highScores: "Bestenliste",
    yourScore: "Deine Punktzahl",
    yourRank: "Rang",
    noHighScores: "Noch keine Bestenliste. Sei der Erste!",
    anonymous: "Anonym",
    close: "Schließen",

    // Maze Game
    maze: "Labyrinth",
    mazeDescription: "Finde deinen Weg\ndurchs Labyrinth!",
    mazeInstructions: "Nutze Pfeiltasten (oder WASD), um von ✅ zu 🎯 zu gehen.",
    mazeControls: "Mit Pfeiltasten/WASD bewegen. Erreiche 🎯 zum Gewinnen.",
    youWin: "Du hast das Labyrinth geschafft!",
    moves: "Züge",
    finalMoves: "Gesamtzüge",

    // Ops-tickles
    opsTickles: "Ops-tickles",
    opsTicklesDescription: "Schieße die Sterne,\ndie zum Ziel passen!",
    opsTicklesInstructions:
      "Sterne fallen mit Rechnungen — schieße nur die, die der Zahl im Sternburst entsprechen!\nLass andere Sterne vorbeiziehen. Nicht zusammenstoßen, keine Flugzeuge schießen, und keinen falschen Stern treffen.\nWenn ein passender Stern vorbeifällt, beginnt das Spiel von vorn.",
    opsTicklesHint: "← → bewegen · Leertaste abfeuern",
    opsTicklesShoot: "Abfeuern",
    opsTicklesHighScores: "Ops-tickles Bestenliste",
    opsTicklesTarget: "Ziel",
    opsTicklesTargetHint: "Schieße Sterne, deren Rechnung dieser Zahl entspricht",

    chess: "Schach",
    chessDescription: "Spiel gegen einen Freund\noder den Computer.",
    chessChooseMode: "Wähle einen Modus.",
    chessModeEasy: "Leicht",
    chessModeBeginner: "Anfänger",
    chessModeIntermediate: "Mittel",
    chessModeHard: "Schwer",
    chessModeMaster: "Meister",
    chessIfYouWant: "Wenn du willst",
    chessWantPlaceholder: "Wählen",
    chessModeLabel: "Modus",
    chessModePlaceholder: "Wähle einen Modus",
    chessChooseModeFirst: "Wähle zuerst einen Modus.",
    chessHuman: "Mensch",
    chessPlayerLabel: "Spieler",
    chessPlayerPlaceholder: "Wähle einen Spieler",
    chessChooseFirst: "Wähle zuerst Computer oder Mensch.",
    chessNotifyMe: "Benachrichtige mich",
    chessPlayerHere: "Da ist ein Spieler.",
    chessChat: "Chat",
    chessChatEmpty: "Sag hallo.",
    chessChatPlaceholder: "Nachricht tippen",
    chessChatSend: "Senden",
    chessOpponentLabel: "Gegner",
    chessOpponentPlaceholder: "Wähle einen Gegner",
    chessNoOpponents:
      "Niemand sonst wartet in diesem Modus. Bleib auf dieser Seite — dein Name steht auf der Liste — und ein Freund im selben Modus kann dich wählen.",
    chessYouAreListed:
      "Die Namen in diesem Modus stehen von A bis Z. Wähle jemanden und drücke Auswählen. Oder warte hier, dann kann die Person dich wählen.",
    chessSelect: "Auswählen",
    chessSelecting: "Verbinden…",
    chessYourTurn: "Du bist dran",
    chessOpponentTurn: "{name} ist dran",
    chessComputer: "Computer",
    chessOpponent: "Gegner",
    chessYou: "Du",
    chessCheck: "Schach",
    chessYouWin: "Du gewinnst",
    chessYouLose: "Du verlierst",
    chessDraw: "Remis",
    chessCheckmate: "Schachmatt. Diese Person verliert.",
    chessStalemate: "Patt — niemand verliert.",
    chessInsufficient: "Zu wenige Figuren, um noch zu gewinnen.",
    chessOpponentLeft: "Die andere Person hat das Spiel verlassen, du gewinnst.",
    chessYouLeft: "Du hast das Spiel verlassen.",
    chessWhite: "Weiß",
    chessBlack: "Schwarz",
    chessPlayAgain: "Nochmal spielen",
    chessPromotion: "Wähle eine Figur",
    chessConnectError:
      "Die anderen Spieler sind nicht erreichbar. Läuft der Spielserver?",
    chessAlreadyPlaying:
      "Diese Person hat gerade ein anderes Spiel begonnen. Wähle jemand anderen.",
    chessKing: "König",
    chessQueen: "Dame",
    chessRook: "Turm",
    chessBishop: "Läufer",
    chessKnight: "Springer",
    chessPawn: "Bauer",

    memory: "Memory",
    memoryDescription: "Finde die Paare\nmit einem Freund.",
    memoryIfYouWant: "Wenn du willst",
    memoryWantPlaceholder: "Wählen",
    memoryPractice: "Üben",
    memoryHuman: "Gegen einen Menschen spielen",
    memoryYourTurn: "Du bist dran",
    memoryAllOpen: "Alle Karten sind offen.",
    memoryYouHave: "Du hast {count} Karten",
    memoryClose: "Schließen",
    memoryCardsError: "Die Karten konnten nicht geöffnet werden.",
    memoryPlayerLabel: "Spieler wählen",
    memoryPlayerPlaceholder: "Wähle einen Spieler",
    memoryGo: "Los",
    memoryGoing: "Verbinden…",
    memoryNoOpponents:
      "Niemand sonst wartet. Bleib auf dieser Seite — dein Name steht auf der Liste — und ein Freund kann dich wählen.",
    memoryYouAreListed:
      "Die Namen stehen von A bis Z. Wähle jemanden und drücke Los. Oder warte hier, dann kann die Person dich wählen.",
    memoryConnectError:
      "Die anderen Spieler sind nicht erreichbar. Läuft der Spielserver?",
    memoryAlreadyPlaying:
      "Diese Person hat gerade ein anderes Spiel begonnen. Wähle jemand anderen.",
    memoryPlayingWith: "Du spielst gegen {name}",
    memoryYou: "Du",
    memoryOpponent: "Gegner",
    memoryOpponentLeft: "Die andere Person hat das Spiel verlassen.",
    memoryYouLeft: "Du hast das Spiel verlassen.",

    solitaire: "Solitär",
    solitaireDescription: "Räum den Tisch ab.\nDie schnellste Zeit gewinnt.",
    solitaireNewDeal: "Neu geben",
    solitaireWon: "Der Tisch ist leer",
    solitaireStock: "Karte ziehen",
    solitaireFoundation: "Ablage",
    solitaireEmpty: "Leere Reihe",
    solitaireHint: "Hinweis",
    solitaireHintDraw: "Zieh eine Karte.",
    solitaireHintMove: "Lege {card}.",
    solitaireHintNone: "Kein Zug zum Zeigen.",
    solitaireHintNeed: "Dieser Hinweis kostet {cost} Sterne.",

    // Arcade sections
    earnPoints: "Punkte verdienen",
    spendPoints: "Punkte ausgeben",
    free: "KOSTENLOS",

    // Display Name
    setDisplayName: "Anzeigename festlegen",
    chooseLanguage: "Wähle deine Sprache",
    displayNameDescription: "Wähle einen Anzeigenamen, der in Bestenlisten und Highscores angezeigt wird!",
    displayNamePlaceholder: "Anzeigename (2–20 Zeichen)",
    displayNameRequired: "Anzeigename ist erforderlich",
    displayNameTooShort: "Anzeigename muss mindestens 2 Zeichen lang sein",
    displayNameTooLong: "Anzeigename darf maximal 20 Zeichen lang sein",
    displayNameError: "Fehler beim Festlegen des Anzeigenamens. Bitte versuche es erneut.",
    saveDisplayName: "Anzeigename speichern",
    saving: "Speichern...",
    cancel: "Abbrechen",
    playerLabel: "Spieler",
    editDisplayName: "Anzeigenamen bearbeiten",
    profileMenu: "Profilmenü",
    playMusic: "Musik abspielen",
    muteMusic: "Musik stumm",
    changeLanguage: "Sprache",
    changeMode: "Modus",
    modePurple: "Gelb",
    modePink: "Lila",
    modeYellow: "Weiß",
    modeBlue: "Blau",
    modeGreen: "Grün",
    modeRed: "Rot",
    myShipments: "Meine Sendungen",
    myShipmentsSubtitle:
      "Verfolge deine eingelösten Belohnungen und den Versandstatus.",
    shipmentsEmpty: "Du hast noch keine Belohnungen eingelöst.",
    shipmentsError:
      "Sendungen konnten nicht geladen werden. Bitte versuche es erneut.",
    shipmentStatusPending: "Ausstehend",
    shipmentStatusOnTheWay: "Unterwegs",
    shipmentStatusShipped: "Versendet",
    shipmentDelete: "Löschen",
    shipmentDeleting: "Löschen…",
    shipmentDeleteConfirm: "Bist du sicher?",
    shipmentDeleteError:
      "Bestellung konnte nicht gelöscht werden. Bitte versuche es erneut.",
    reportProblem: "Problem melden",
    reportProblemSubtitle:
      "Beschreibe, was schiefgelaufen ist. Wir sehen deine Nachricht im Admin-Bereich.",
    reportProblemMessageLabel: "Nachricht",
    reportProblemPlaceholder: "Beschreibe das Problem…",
    reportProblemSend: "Senden",
    reportProblemSending: "Senden…",
    reportProblemRequired: "Bitte gib eine Nachricht ein.",
    reportProblemTooLong: "Bitte halte deine Nachricht unter 2000 Zeichen.",
    reportProblemSuccess: "Danke — dein Bericht wurde gesendet.",
    reportProblemError:
      "Bericht konnte nicht gesendet werden. Bitte versuche es erneut.",

    // Error messages
    insufficientPoints: "Nicht genug Punkte",
    insufficientPointsMessage:
      "Bitte verdiene zuerst einige Punkte, bevor du dieses Spiel spielst!",
    ok: "OK",

    // Languages
    english: "English",
    german: "Deutsch",
  },
};

export const keyboardLayouts = {
  en: "QWERTYUIOPASDFGHJKLZXCVBNM".split(""),
  de: "QWERTZUIOPASDFGHJKLÄÖÜYXCVBNM".split(""),
};
